export default {
    data() {
        return {
            isIpValid: false,
            activeReference: null,
            wasVariationChosen: false,
            wasFallbackSet: false,
            connectionAttempts: 0,
            experiences: {

                //TEST
                'convert-test':                         {id: '1004176179', variation: 'A'},

                //OLD
                'overview-page-usp':                    {id: '1004130370', variation: 'A'},
                'destination':                          {id: '1004134322', variation: 'A'},
                'no-payment-required-yet':              {id: '1004148795', variation: 'A'},
                'show-review-overview-website':         {id: '1004153018', variation: 'A'},
                'show-nps-review-overview':             {id: '1004157450', variation: 'A'},
                'show-review-score-booking-process':    {id: '1004162754', variation: 'A'},
                'show-top-usps-booking-process':        {id: '1004165186', variation: 'A'},
                'open-bp-link-current-window':          {id: '1004168987', variation: 'A'},

                //ACTIVE
                'bp-force-payment':                     {id: '1004171953', variation: 'A'},
            },
        }
    },

    created() {

    },

    mounted() {

    },

    methods: {

        determineVariation(reference) {

            this.activeReference = reference;

            const attempt = () => {

                this.connectionAttempts++;

                let variation = window.convert?.currentData?.experiences[this.experiences[reference].id]?.variation?.name ?? null;

                if (variation !== null) {

                    this.experiences[reference].variation = variation.substring(0, 1);
                    // this.experiences[reference].variation = 'A';//tmp
                    this.wasVariationChosen = true;

                    this.setDebugInfo();

                } else if (this.connectionAttempts < 6) {
                // } else if (this.connectionAttempts < 1) {

                    setTimeout(() => {
                        attempt();
                    }, 250);

                } else {

                    // variation = 'A';
                    // variation = 'B';
                    // const variation = Math.random() < 0.5 ? "A" : "B";

                    this.experiences[reference]['variation'] = variation;
                    this.wasVariationChosen = true;
                    this.wasFallbackSet = true;
                }

                //debug
                if (this.wasVariationChosen && this.showDebug) {
                    let target = document.querySelector('div[data-reference="ab-test-debug"]');

                    if (target) {
                        target.innerHTML = 'AB-test: ' + variation;
                    }
                }

                if (this.showDebug) {
                    console.log('connectionAttempts:');
                    console.log(this.connectionAttempts);
                    console.log('window.convert:');
                    console.log(window.convert);
                    console.log('variation:');
                    console.log(variation);
                    console.log('this.isIpValid:');
                    console.log(this.isIpValid);
                    this.listTests();
                }
            };

            attempt();
        },

        setVariation(reference, variation) {

            if (! this.experiences || ! this.experiences[reference]) {
                return;
            }

            return this.experiences[reference].variation = variation;
        },

        listTests() {

            const experiences = window.convert?.currentData?.experiences;

            if (experiences) {
                for (const key in experiences) {
                    if (Object.hasOwnProperty.call(experiences, key)) {
                        const content = experiences[key];
                        // console.log(`Key: ${key}, Contents:`, content);
                        // console.log(key);
                        // console.log(content.variation);
                        // console.log(content.variation.name);
                        const line = key + ': ' + content.variation.name;
                        console.log(line);
                    }
                }
            }
        },

        setDebugInfo() {

            //debug

            const divVisitorId = document.querySelector('div[data-reference="convert-visitor-id"]');

            if (divVisitorId) {
                divVisitorId.innerHTML = this.visitorId;
            }

            const divVariation = document.querySelector('div[data-reference="convert-variation"]');

            if (divVariation) {
                divVariation.innerHTML = this.activeVariation;
            }

            const divExperienceId = document.querySelector('div[data-reference="convert-experience-id"]');

            if (divExperienceId) {
                divExperienceId.innerHTML = this.experienceId;
            }

            //if any hidden fields are set, auto-fill them
            const inputHiddenVisitorId = document.querySelector('input[type="hidden"][name="convert_visitor_id"]');

            if (inputHiddenVisitorId) {
                inputHiddenVisitorId.value = this.visitorId;
            }

            const inputHiddenExperienceId = document.querySelector('input[type="hidden"][name="convert_experience_id"]');

            if (inputHiddenExperienceId) {
                inputHiddenExperienceId.value = this.experienceId;
            }
        }
    },

    computed: {

        //When we're doing an A/B test, sometimes we first hide both option A and B until
        //a variation was chosen. This can be used to do that check.
        canElementBeShown() {
            return this.isIpValid || this.wasVariationChosen;
        },

        isRealVariationSet() {
            return this.wasVariationChosen && ! this.wasFallbackSet;
        },

        activeConnectionAttempts() {
            return this.connectionAttempts;
        },

        activeVariation() {
            return this.experiences[this.activeReference]?.variation ?? 'A';
        },

        experienceId() {
            return this.experiences[this.activeReference]?.id;
        },

        visitorId() {
            return window.convert?.getAllVisitorData()?.visitorId ?? null;
        },

        showDebug() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            if (urlSearchParams.has('ab')) {
                return true;
            }

            return false;
        }

    },
}
